import { PasswordRecoveryRepository } from '@/Account/domain/PasswordRecoveryRepository'
import { PasswordRecoveryModel, ResetPasswordModel } from '../domain/PasswordRecoveryModel'
import { PasswordRecoveryData, ResetPasswordData, TokenData } from '@/Account/ui/hooks'
import { HttpModel } from '@/Shared/domain'

interface IPasswordRecovery {
  verifyIdentity: (data: PasswordRecoveryData) => Promise<HttpModel<PasswordRecoveryModel>>
  resendEmail: (data: PasswordRecoveryData) => Promise<HttpModel<string>>
  updatePassword: (data: ResetPasswordData, userName: string) => Promise<HttpModel<ResetPasswordModel>>
  validateToken: (data: TokenData) => Promise<HttpModel<boolean>>
}

export const PasswordRecoveryContract = (PasswordRecoveryRepository: PasswordRecoveryRepository): IPasswordRecovery => ({
  verifyIdentity: async (data: PasswordRecoveryData): Promise<HttpModel<PasswordRecoveryModel>> =>
    await PasswordRecoveryRepository.VerifyIdentity(data),
  resendEmail: async (data: PasswordRecoveryData): Promise<HttpModel<string>> =>
    await PasswordRecoveryRepository.ResendEmail(data),
  updatePassword: async (data: ResetPasswordData, userName: string): Promise<HttpModel<ResetPasswordModel>> =>
    await PasswordRecoveryRepository.UpdatePassword(data, userName),
  validateToken: async (data: TokenData): Promise<HttpModel<boolean>> =>
    await PasswordRecoveryRepository.ValidateToken(data),
})
